import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ICreatePriceBandBody, ICreatePriceBandResponse } from './types';

export const createPriceBand = async (
  requestBody: ICreatePriceBandBody,
  priceSchemeId: string,
): Promise<ICreatePriceBandResponse['data']> => {
  try {
    const response = await fetch(`${API_URL}/pricing/price-bands`, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
        [PRICE_SCHEME_HEADER]: priceSchemeId,
      },
    });

    if (!response.ok) {
      throw new Error();
    }

    const { data }: ICreatePriceBandResponse = await response.json();
    return data;
  } catch {
    throw new Error('Something went wrong whilst creating price band.');
  }
};
